import { validateCheckoutUrl } from '@common/validation-schemas';

import { stripePayment } from 'services';
import { StripePaymentRequest } from 'services/payment-intl';

import { persistStripePaymentReturn, redirectToStripeCheckout } from './utils';

/** The standalone Stripe flow, shared by Finalize and the authenticated SDK continuation. */
export async function startStripeCheckout(
  payment: StripePaymentRequest,
  invalidResponseMessage: string,
  onProcessing: () => void,
): Promise<void> {
  const { data } = await stripePayment(payment);
  if (!data || 'message' in data) {
    throw new Error(data?.message || invalidResponseMessage);
  }
  if (!data.paymentId || !data.checkoutSessionId || !data.checkoutSessionUrl) {
    throw new Error(invalidResponseMessage);
  }
  const destination = validateCheckoutUrl(data.checkoutSessionUrl);
  onProcessing();
  persistStripePaymentReturn({
    paymentId: String(data.paymentId),
    stripePaymentKey: data.checkoutSessionId,
  });
  redirectToStripeCheckout(destination);
}
